export enum AppTypeEnum {
  'apple' = 'iOS',
  'google' = 'Android'
}
